import React from 'react';
import { useSiteContext } from '../../SiteContext';
import { Alert } from '@material-ui/lab';
export const ComponentRenderer = ({ component, componentProps }) => {
    const { plugins } = useSiteContext();
    const plugin = plugins.find(p => p.type === component.type);
    if (!plugin) {
        return (React.createElement(Alert, { severity: 'error' },
            "Component plugin \"",
            component.name,
            "\" not found"));
    }
    return (React.createElement(plugin.component, Object.assign({ component: component }, component.props, componentProps)));
};
export default ComponentRenderer;
//# sourceMappingURL=ComponentRenderer.js.map